import BaseRepository from "~/repositories/BaseRepository";
import MediumFollowModel from "~/models/MediumFollowModel";

class MediumFollowsRepository extends BaseRepository {
  async show(params = {}): Promise<MediumFollowModel> {
    const url = "/api/v1/medium_follow";
    const mediumFollowParams = new MediumFollowModel(params);
    const result = await this._get(url, mediumFollowParams.toApiParams());
    return new MediumFollowModel(result.data);
  }
  async create(params = {}): Promise<MediumFollowModel> {
    const url = "/api/v1/medium_follow";
    const mediumFollowParams = new MediumFollowModel(params);
    const result = await this._post(url, mediumFollowParams.toApiParams());
    return new MediumFollowModel(result.data);
  }
  async destroy(params = {}): Promise<MediumFollowModel> {
    const url = "/api/v1/medium_follow";
    const mediumFollowParams = new MediumFollowModel(params);
    await this._delete(url, mediumFollowParams.toApiParams());
  }
}
export default MediumFollowsRepository;
